import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import api from '../api/axios';
import { useNavigate } from 'react-router-dom';
import Sidebarnew from "./NewUI/Sidebarnew";
import Navigationnew from "./NewUI/Navigationnew";

// ✅ ALL BACKEND LOGIC UNCHANGED
const Dashboard = () => {
  const navigate = useNavigate();

  const [animateBars, setAnimateBars] = useState(false);
  // const [openActionMenu, setOpenActionMenu] = useState(null);
// Add these to the top of your Dashboard function
const [selectedAgent, setSelectedAgent] = useState(null);
// const [activeAgents, setActiveAgents] = useState([]);
// const [remainingActiveAgents, setRemainingActiveAgents] = useState([]);
  const [stats, setStats] = useState({
    totalQueries: "0",
    timeSaved: "0 hrs", // ✅ Add this line here
    needsAttention: "0",
    accuracyRate: "0%",
    averageRating: "0",
    trend: "+0% vs last month",
    usageByAgent: [],
    missedQueries: [],
    agentPerformance: [],
    unverifiedDocuments: [],
    totalDocs: 0,
    commonMissedQueries: [] // ✅ Added here
  });

  // ✅ UNCHANGED
  const [latestUpdates, setLatestUpdates] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => setAnimateBars(true), 100);

    const fetchSummary = async () => {
      try {
        const res = await api.get("/dashboard/summary");
        setStats(res.data);
      } catch (err) {
        console.error("Dashboard Fetch Error:", err);
      }
    };

    const fetchLatestUpdates = async () => {
      try {
        const res = await api.get("/dashboard/latest-updates");
        setLatestUpdates(res.data);
      } catch (err) {
        console.error("Latest Updates Fetch Error:", err);
      }
    };
    

    fetchSummary();
    fetchLatestUpdates();

    // const handleClickOutside = () => setOpenActionMenu(null);
    // window.addEventListener('click', handleClickOutside);
    return () => {
      clearTimeout(timer);
      // window.removeEventListener('click', handleClickOutside);
    };
  }, []);
//   useEffect(() => {

//   if (
//     stats.usageByAgent &&
//     stats.usageByAgent.length > 0 &&
//     !selectedAgent
//   ) {
//     setSelectedAgent(stats.usageByAgent[0]);
//   }

// }, [stats, selectedAgent]);

  // ✅ UNCHANGED
  const formatTimeAgo = (dateString) => {
    const diff = Math.floor((new Date() - new Date(dateString)) / (1000 * 60));
    if (diff < 60) return `${diff} mins ago`;
    const hours = Math.floor(diff / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  };

  // ✅ UNCHANGED — metric definitions
 const metrics = [
    { label: "TOTAL QUERIES",      value: stats.totalQueries,  trend: stats.trend, accentColor: "#4B7BF5" },
    { label: "TIME SAVED",         value: stats.timeSaved,     trend: stats.trend, accentColor: "#8B5CF6" }, // ✅ Now strictly dynamic
    { label: "ACCURACY RATE",      value: stats.accuracyRate,  trend: stats.trend, accentColor: "#10B981" },
// ...
    { label: "AVG USER RATING",   value: (
  <>
    {stats.averageRating}
    <span className="db-rating-star">★</span>
  </>
), trend: stats.trend, accentColor: "#F59E0B" },
    { label: "NEED ATTENTION",     value: stats.needsAttention, trend: stats.trend, accentColor: "#EF4444" },
  ];

  // Success% color logic
  const getSuccessColor = (rate) => {
    const num = parseFloat(rate);
    if (num >= 90) return '#10B981';
    if (num >= 70) return '#F59E0B';
    return '#EF4444';
  };
  const getSmartCategory = (query) => {

  const q = query.toLowerCase();

  // ONBOARDING
  if (
    q.includes("create account") ||
    q.includes("signup") ||
    q.includes("login") ||
    q.includes("onboard") ||
    q.includes("joining")
  ) {
    return "Onboarding";
  }

  // POLICIES
  if (
    q.includes("policy") ||
    q.includes("rules") ||
    q.includes("guidelines") ||
    q.includes("compliance")
  ) {
    return "Policies";
  }

  // LEAVE & ATTENDANCE
  if (
    q.includes("leave") ||
    q.includes("attendance") ||
    q.includes("holiday") ||
    q.includes("vacation")
  ) {
    return "Leave & Attendance";
  }

  // REMOTE WORK
  if (
    q.includes("remote") ||
    q.includes("work from home") ||
    q.includes("wfh") ||
    q.includes("hybrid")
  ) {
    return "Remote Work";
  }

  // FINANCE
  if (
    q.includes("salary") ||
    q.includes("invoice") ||
    q.includes("payment") ||
    q.includes("finance") ||
    q.includes("budget")
  ) {
    return "Finance";
  }

  // DOCUMENTS
  if (
    q.includes(".pdf") ||
    q.includes(".docx") ||
    q.includes(".jpg") ||
    q.includes("document") ||
    q.includes("file")
  ) {
    return "Documents";
  }

  return "General";
};

//helper fun
const shortenQuery = (text) => {

  if (!text) return "";

  // remove extra spaces/new lines
  const cleaned = text
    .replace(/\s+/g, " ")
    .trim();

  // if already short
  if (cleaned.length <= 65) {
    return cleaned;
  }

  // smart shorten at word boundary
  return cleaned.substring(0, 65).split(" ").slice(0, -1).join(" ") + "...";
};

  // Category pill colors
  const categoryColors = {
    'Onboarding':       { bg: '#EFF6FF', color: '#3B82F6' },
    'Policies':         { bg: '#F5F3FF', color: '#7C3AED' },
    'Leave & Attendance': { bg: '#ECFDF5', color: '#059669' },
    'Remote Work':      { bg: '#FFF7ED', color: '#D97706' },
    'Finance':          { bg: '#FEF2F2', color: '#DC2626' },
  };

  const getCategoryStyle = (cat) => {
    return categoryColors[cat] || { bg: '#F1F5F9', color: '#64748B' };
  };

  // Update bullet colors
  const updateBulletColors = ['#4B7BF5', '#4B7BF5', '#10B981', '#10B981', '#F59E0B'];

  return (
<div className="db-page-layout dashboard-page">
    {/* FLOATING SIDEBAR */}
    <aside className="db-sidebar-shell">
<Sidebarnew
  selectedAgent={selectedAgent}
/>
   </aside>

    {/* MAIN AREA */}
    <div className="db-main-wrapper">

      {/* NEW TOP NAVBAR */}
      <div className="db-topbar-shell">
<Navigationnew
  selectedAgent={selectedAgent}
  setSelectedAgent={setSelectedAgent}
  // remainingActiveAgents={remainingActiveAgents}
/>      </div>

      {/* DASHBOARD */}
      <div className="db-container">

        <div className="db-content">

          {/* PAGE HEADER */}
          <div className="db-page-header">
            <h1>Dashboard</h1>
            <p>View quick report of your application</p>
          </div>

          {/* ───────────────── METRIC CARDS ───────────────── */}
          <div className="db-metrics-row">

            {metrics.map((m, i) => {

              const metricIcons = [
                "/images/totalquery.svg",
                "/images/timesaved.svg",
                "/images/accuracy.svg",
                "/images/ratings.svg",
                "/images/attention.svg",
              ];

              return (
                <div
                  key={i}
                  className="db-metric-card"
                  style={{
                    '--accent': m.accentColor
                  }}
                >

                  <div className="db-metric-top-bar" />

                  <div className="db-metric-card-top">

                    <div className="db-metric-left">

                      <div className="db-metric-label">
                        {m.label}
                      </div>

                      <div className="db-metric-value">
                        {m.value}
                      </div>

                    </div>

                    <div className="db-metric-icon-box">

                      <img
                        src={metricIcons[i]}
                        alt=""
                        className="db-metric-icon"
                      />

                    </div>

                  </div>

                  <div className="db-metric-trend">
                    {m.trend}
                  </div>

                </div>
              );
            })}

          </div>

          {/* ───────────────── ROW 1 ───────────────── */}
          <div className="db-row">

            {/* AGENT PERFORMANCE */}
            <div className="db-card db-card--left">

              <div className="db-card-header">

                <span className="db-card-title">
                  Agent Performance
                </span>

              </div>

              <div className="db-table-wrap">

                <table className="db-table">

                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Agent</th>
                      <th>Queries</th>
                      <th>Success %</th>
                      <th>Missed</th>
                    </tr>
                  </thead>

                
<tbody>

  {stats.agentPerformance &&
  stats.agentPerformance.length > 0 ? (

    stats.agentPerformance.map((agent, i) => (

      <tr key={i}>

        <td className="db-td-muted">
          {agent.no || i + 1}
        </td>

        <td className="db-td-name">
          {agent.name}
        </td>

        <td>
          {agent.queries}
        </td>

        <td>

          <div className="db-success-wrap">

            <span
              style={{
                color: getSuccessColor(agent.successRate),
                fontWeight: 600,
                fontSize: '0.74rem',
                minWidth: '34px'
              }}
            >
              {agent.successRate}
            </span>

            <div className="db-success-bar-bg">

              <div
                className="db-success-bar-fill"
                style={{
                  width: animateBars
                    ? agent.successRate
                    : '0%',

                  backgroundColor:
                    getSuccessColor(agent.successRate)
                }}
              />

            </div>

          </div>

        </td>

        <td>

          <span
            className="db-missed-badge"
            style={{
              background:
                parseInt(agent.missed) > 0
                  ? '#FEF2F2'
                  : '#ECFDF5',

              color:
                parseInt(agent.missed) > 0
                  ? '#EF4444'
                  : '#10B981'
            }}
          >
            {agent.missed}
          </span>

        </td>

      </tr>

    ))

  ) : (

    <tr>

      <td
        colSpan="5"
        className="db-empty"
      >
        No activity found
      </td>

    </tr>

  )}

</tbody>




                </table>

              </div>

            </div>

            {/* USAGE BY AGENT */}
            <div className="db-card db-card--right">

              <div className="db-card-header">

                <span className="db-card-title">
                  Usage by Agent
                </span>

                <span className="db-card-subtitle">
                  {stats.usageByAgent.length} active agents
                </span>

              </div>

              <div className="db-usage-list">

                {(() => {

                  const maxQ = Math.max(
                    ...stats.usageByAgent.map(
                      a => a.queries
                    ),
                    1
                  );

                  return stats.usageByAgent.map((agent, i) => (

                    <div
                      key={i}
                      className="db-usage-row"
                    >

                      <div className="db-usage-meta">

                        <span className="db-usage-name">
                          {agent.name}
                        </span>

                        <span className="db-usage-queries">
                          {agent.queries.toLocaleString()} queries
                        </span>

                      </div>

                      <div className="db-usage-bar-bg">

                        <div
                          className="db-usage-bar-fill"
                          style={{
                            width: animateBars
                              ? `${(agent.queries / maxQ) * 100}%`
                              : '0%',

                            backgroundColor: agent.color,
                          }}
                        />

                      </div>

                    </div>

                  ));
                })()}

                {stats.usageByAgent.length === 0 && (
                  <div className="db-empty">
                    No usage data available.
                  </div>
                )}

              </div>

            </div>

          </div>

        {/* ───────────────── ROW 2 ───────────────── */}
<div className="db-row">

  {/* DOCUMENTS */}
 <div className="db-card db-card--left">

  <div className="db-card-header">

    <span className="db-card-title">
      Documents Needing Verification
    </span>

    {stats.unverifiedDocuments &&
    stats.unverifiedDocuments.length > 0 && (

      <span className="db-badge db-badge--orange">
        {stats.unverifiedDocuments.length} PENDING
      </span>

    )}

  </div>

  <div className="db-table-wrap">

    <table className="db-table">

      <thead>

        <tr>

          <th style={{ width: '40px' }}>
            No.
          </th>

          <th>
            Document Title
          </th>

          <th>
            Date Added
          </th>

          <th className="db-th-center">
            Actions
          </th>

        </tr>

      </thead>

      <tbody>

        {stats.unverifiedDocuments &&
        stats.unverifiedDocuments.length > 0 ? (

          stats.unverifiedDocuments.map((doc, i) => (

            <tr key={i}>

              <td className="db-td-muted">
                {i + 1}
              </td>

              <td className="db-td-name">
                {doc.title}
              </td>

              <td className="db-td-muted">
                {doc.date}
              </td>

              <td className="db-th-center">

                <button
                  className="db-goto-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/kb');
                  }}
                >
                  GO TO FILE
                </button>

              </td>

            </tr>

          ))

        ) : (

          <tr>

            <td
              colSpan="4"
              className="db-empty"
            >
              {stats.totalDocs === 0
                ? "No documents attached yet"
                : "All documents are verified!"}
            </td>

          </tr>

        )}

      </tbody>

    </table>

  </div>

</div>

  {/* MISSED QUERIES */}
  <div className="db-card db-card--right">

    <div className="db-card-header">

      <span className="db-card-title">
        Missed Queries
      </span>

      {stats.missedQueries &&
      stats.missedQueries.length > 0 && (

        <span className="db-badge db-badge--blue">
          {stats.missedQueries.length} NEW
        </span>

      )}

    </div>

    <div className="db-table-wrap">

      <table className="db-table">

        <thead>
          <tr>

            <th>
              Query
            </th>

            <th>
              Related Doc
            </th>

          </tr>
        </thead>

        <tbody>

          {stats.missedQueries &&
          stats.missedQueries.length > 0 ? (

            stats.missedQueries.map((query, i) => (

              <tr key={i}>

                <td className="db-td-name">
              {shortenQuery(query.query)}
                </td>

              <td>

  {query.document === "No documents linked" ? (

    <span className="db-doc-add">

      No doc ·

      <span className="db-doc-add-link">
        + Add
      </span>

    </span>

  ) : (

    <span
      className="db-doc-link"
      style={{ cursor: 'pointer' }}
      onClick={() => navigate('/kb')}
    >

      <span className="db-doc-icon">
        📄
      </span>

      {query.document}

    </span>

  )}

</td>

              </tr>

            ))

          ) : (

            <tr>

              <td
                colSpan="2"
                className="db-empty"
              >
                No missed queries found
              </td>

            </tr>

          )}

        </tbody>

      </table>

    </div>

  </div>

</div>

{/* ───────────────── ROW 3 ───────────────── */}
<div className="db-row">

  {/* COMMON QUERIES */}
  <div className="db-card db-card--left">

    <div className="db-card-header">

      <span className="db-card-title">
        Most Common Queries
      </span>

    </div>

    <div className="db-table-wrap">

      <table className="db-table">

        <thead>
          <tr>

            <th>
              Query
            </th>

            <th>
              Category
            </th>

            <th>
              Freq.
            </th>

          </tr>
        </thead>

        <tbody>

          {stats.commonMissedQueries &&
          stats.commonMissedQueries.length > 0 ? (

            stats.commonMissedQueries.map((item, i) => {

// const getSmartCategory = (query) => {

//   const q = query.toLowerCase();

//   // ONBOARDING
//   if (
//     q.includes("create account") ||
//     q.includes("signup") ||
//     q.includes("login") ||
//     q.includes("onboard") ||
//     q.includes("joining")
//   ) {
//     return "Onboarding";
//   }

//   // POLICIES
//   if (
//     q.includes("policy") ||
//     q.includes("rules") ||
//     q.includes("guidelines") ||
//     q.includes("compliance")
//   ) {
//     return "Policies";
//   }

//   // LEAVE & ATTENDANCE
//   if (
//     q.includes("leave") ||
//     q.includes("attendance") ||
//     q.includes("holiday") ||
//     q.includes("vacation")
//   ) {
//     return "Leave & Attendance";
//   }

//   // REMOTE WORK
//   if (
//     q.includes("remote") ||
//     q.includes("work from home") ||
//     q.includes("wfh") ||
//     q.includes("hybrid")
//   ) {
//     return "Remote Work";
//   }

//   // FINANCE
//   if (
//     q.includes("salary") ||
//     q.includes("invoice") ||
//     q.includes("payment") ||
//     q.includes("finance") ||
//     q.includes("budget")
//   ) {
//     return "Finance";
//   }

//   // DOCUMENTS
//   if (
//     q.includes(".pdf") ||
//     q.includes(".docx") ||
//     q.includes(".jpg") ||
//     q.includes("document") ||
//     q.includes("file")
//   ) {
//     return "Documents";
//   }

//   return "General";
// };
const category =
  getSmartCategory(item.question);

const style =
  getCategoryStyle(category);
              return (

                <tr key={i}>

               <td className="db-td-name">
  {shortenQuery(item.question)}
</td>

                  <td>

                    <span
                      className="db-category-pill"
                      style={{
                        background: style.bg,
                        color: style.color
                      }}
                    >
                    {category}
                    </span>

                  </td>

                  <td>
                 {item.freq}
                  </td>

                </tr>

              );
            })

          ) : (

            <tr>

              <td
                colSpan="3"
                className="db-empty"
              >
                No common queries available
              </td>

            </tr>

          )}

        </tbody>

      </table>

    </div>

  </div>

  {/* LATEST UPDATES */}
  <div className="db-card db-card--right">

    <div className="db-card-header">

      <span className="db-card-title">
        Latest Updates
      </span>

    </div>

    <div className="db-updates-list">

      {latestUpdates &&
      latestUpdates.length > 0 ? (

        latestUpdates.map((update, i) => (

          <div
            key={i}
            className="db-update-item"
          >

            <div
              className="db-update-dot"
              style={{
                background:
                  updateBulletColors[
                    i % updateBulletColors.length
                  ]
              }}
            />

            <div className="db-update-content">

       <div className="db-update-title">
  {update.title}
</div>

<div className="db-update-subtitle">
  {update.name}
</div>
            </div>

           <div className="db-update-time">
  {formatTimeAgo(update.time)}
</div>

          </div>

        ))

      ) : (

        <div className="db-empty">
          No recent activity found
        </div>

      )}

    </div>

  </div>

</div> {/* db-row */}

</div> {/* db-content */}

</div> {/* db-container */}

</div> {/* db-main-wrapper */}

</div> 

);
};

export default Dashboard;